<template lang="pug">
  v-dialog(v-model="isOpen" width="25%" persistent)
    v-card
      v-card-text.pa-4
        v-layout.justify-center.column.align-center
          v-icon.error--text(size="4em") warning
          .title.pt-4.text-xs-center {{ errorTitle }}
          .subheading.px-3.py-4.text-xs-center {{ errorDetail }}
      v-card-actions.error.click(@click="isOpen = false")
        v-layout.justify-center
          .subheading.py-1.white--text Fermer
</template>

<script>

export default {
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    errorCode() {
      return this.$store.state.errorHandler.error.code;
    },
    errorTitle() {
      return this.$store.state.errorHandler.error.title;
    },
    errorDetail() {
      return this.$store.state.errorHandler.error.detail;
    },
  },
  watch: {
    errorTitle() {
      this.isOpen = true;
    },
  },
};
</script>
